<template>
  <v-tooltip bottom dark>
    <template v-slot:activator="{ on: tooltipOn }">
      <v-btn :class="{ 'v-btn--active': manageActive }" icon to="/manage" v-on="tooltipOn">
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </template>
    <span>Zarządzanie</span>
  </v-tooltip>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('account');

export default {
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      }
    };
  },
  computed: {
    ...mapState(['impersonation']),
    'dialog.loading'() {
      return this.impersonation.isImpersonated.loading;
    },
    manageActive() {
      return this.$route.path.startsWith('/manage');
    }
  },
  methods: {
    ...mapActions(['unImpersonate']),
    async unImpersonateUser() {
      this.dialog.loading = true;
      await this.unImpersonate();

      try {
        await this.$router.replace('/');
        this.dialog.value = false;
        this.dialog.loading = false;
      } catch (e) {
        // can replace with same path
        this.$router.go();
      }
    }
  }
};
</script>

<style scoped></style>
